/**
 * mega-menu.js — نغمة ستور
 * فتح/إغلاق لوحة "جميع الأقسام" (Mega Menu) من عدة أزرار محتملة (الهيدر
 * والشريط السفلي للجوال)، مع دعم مستويات فرعية بالماوس ولوحة المفاتيح،
 * وعرض بديل بملء الشاشة على الجوال. لا تُنشأ Event Listeners مكررة.
 *
 * ملاحظة تصحيح: الرابط <a> داخل كل عنصر ينتقل الآن مباشرة لصفحة القسم
 * دائمًا (بلا preventDefault)؛ فتح/إغلاق اللوحة الفرعية أصبح مسؤولية
 * زر منفصل [data-mega-submenu-toggle] فقط (انظر snippets/mega-menu.liquid).
 */
(function () {
  "use strict";

  var MOBILE_BREAKPOINT = 989;
  var removeFocusTrap = null;
  var lastTrigger = null;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getPanel() {
    return document.querySelector("[data-mega-menu-panel]");
  }

  function openPanel(panel, trigger) {
    panel.removeAttribute("hidden");
    lastTrigger = trigger || lastTrigger;
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    document.querySelectorAll("[data-mega-menu-toggle]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "true");
    });

    if (isMobile()) {
      panel.classList.add("mega-menu--mobile");
      Naghmah.lockScroll();
    }

    removeFocusTrap = Naghmah.trapFocus(panel);

    document.addEventListener("click", onDocumentClick, true);
    document.addEventListener("keydown", onDocumentKeydown, true);
  }

  function closePanel(panel) {
    if (!panel || panel.hasAttribute("hidden")) return;
    panel.setAttribute("hidden", "");
    panel.classList.remove("mega-menu--mobile");
    document.querySelectorAll("[data-mega-menu-toggle]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "false");
    });
    panel.querySelectorAll(".mega-menu__item.is-open").forEach(function (item) {
      item.classList.remove("is-open");
    });
    // تصحيح: كانت حالة is-open تُصفَّر بصريًا هنا لكن aria-expanded على
    // أزرار التوسيع الفرعية يبقى "true" كما هو — يُصفَّر الآن صراحة لكل
    // زر توسعة فرعي داخل اللوحة عند إغلاقها بالكامل.
    panel.querySelectorAll("[data-mega-submenu-toggle]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "false");
    });
    Naghmah.unlockScroll();

    if (removeFocusTrap) {
      removeFocusTrap();
      removeFocusTrap = null;
    }

    document.removeEventListener("click", onDocumentClick, true);
    document.removeEventListener("keydown", onDocumentKeydown, true);
  }

  function onDocumentClick(evt) {
    var panel = getPanel();
    if (!panel) return;
    var clickedTrigger = evt.target.closest("[data-mega-menu-toggle]");
    var clickedInsidePanel = evt.target.closest("[data-mega-menu-panel]");
    if (!clickedTrigger && !clickedInsidePanel) {
      closePanel(panel);
    }
  }

  // دالة موحَّدة: تُغلق اللوحة ثم تُعيد التركيز إلى الزر الفعلي الذي فتحها
  // (lastTrigger)، لا إلى أول زر [data-mega-menu-toggle] يوجَد في الصفحة.
  // تُستخدم من كل مسارات الإغلاق (زر الإغلاق، مفتاح Escape) بدل استدعاء
  // closePanel مباشرة من أي منها بمفرده.
  function closeAndRestoreFocus(panel) {
    closePanel(panel);
    var returnTo = lastTrigger || document.querySelector("[data-mega-menu-toggle]");
    if (returnTo) returnTo.focus();
  }

  function onDocumentKeydown(evt) {
    if (evt.key === "Escape") {
      var panel = getPanel();
      closeAndRestoreFocus(panel);
    }
  }

  function initCloseButtons(panel) {
    panel.querySelectorAll("[data-mega-menu-close]").forEach(function (btn) {
      if (btn.dataset.megaCloseBound === "true") return;
      btn.dataset.megaCloseBound = "true";
      btn.addEventListener("click", function () {
        closeAndRestoreFocus(panel);
      });
    });
  }

  function initSubmenuToggles(panel) {
    var items = panel.querySelectorAll(".mega-menu__item.has-children");

    items.forEach(function (item) {
      var expandBtn = item.querySelector(":scope > .mega-menu__item-row > [data-mega-submenu-toggle]");
      if (!expandBtn || expandBtn.dataset.megaSubBound === "true") return;
      expandBtn.dataset.megaSubBound = "true";

      expandBtn.addEventListener("click", function () {
        // زر التوسيع فقط يتحكم باللوحة الفرعية؛ الرابط المجاور له ينتقل
        // بشكل طبيعي دون أي اعتراض.
        var isOpen = item.classList.contains("is-open");
        item.parentElement
          .querySelectorAll(":scope > .mega-menu__item.is-open")
          .forEach(function (openItem) {
            if (openItem === item) return;
            openItem.classList.remove("is-open");
            // تصحيح: إغلاق عنصر شقيق بصريًا (إزالة is-open) لم يكن يُصفِّر
            // aria-expanded على زر ذلك الشقيق نفسه، فيبقى "true" رغم إغلاقه.
            var siblingToggle = openItem.querySelector(
              ":scope > .mega-menu__item-row > [data-mega-submenu-toggle]"
            );
            if (siblingToggle) siblingToggle.setAttribute("aria-expanded", "false");
          });
        item.classList.toggle("is-open", !isOpen);
        expandBtn.setAttribute("aria-expanded", (!isOpen).toString());
      });

      if (!isMobile()) {
        item.addEventListener("mouseenter", function () {
          item.classList.add("is-open");
          expandBtn.setAttribute("aria-expanded", "true");
        });
        item.addEventListener("mouseleave", function () {
          item.classList.remove("is-open");
          expandBtn.setAttribute("aria-expanded", "false");
        });
      }
    });
  }

  function initMegaMenu() {
    var panel = getPanel();
    if (!panel) return;

    if (panel.dataset.megaMenuInitialized !== "true") {
      panel.dataset.megaMenuInitialized = "true";
      initSubmenuToggles(panel);
      initCloseButtons(panel);
    } else {
      // إعادة ربط عناصر قد تكون أُعيد رسمها ضمن نفس اللوحة عند تحميل قسم آخر
      initSubmenuToggles(panel);
      initCloseButtons(panel);
    }

    document.querySelectorAll("[data-mega-menu-toggle]").forEach(function (trigger) {
      if (trigger.dataset.megaTriggerBound === "true") return;
      trigger.dataset.megaTriggerBound = "true";

      trigger.addEventListener("click", function () {
        var currentPanel = getPanel();
        if (!currentPanel) return;
        var isHidden = currentPanel.hasAttribute("hidden");
        if (isHidden) {
          openPanel(currentPanel, trigger);
        } else {
          closePanel(currentPanel);
        }
      });
    });
  }

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;

  if (Naghmah.registerSection) {
    // "header" تحتوي اللوحة نفسها، و"mobile-bottom-nav" قد يضيف زر تشغيل
    // إضافيًا (open_categories) يحتاج ربطًا عند إعادة تحميل ذلك القسم في
    // محرر الثيم دون إعادة تحميل قسم الهيدر نفسه.
    Naghmah.registerSection("header", function () {
      initMegaMenu();
    });
    Naghmah.registerSection("mobile-bottom-nav", function () {
      initMegaMenu();
    });
  }

  Naghmah.onReady(initMegaMenu);
})();
